<script>
export default {
  name: 'redirectToPortal',
  props: ['route'],
  mounted() {
    console.log('redirect to new portal');
    const portalUrl = process.env.PORTAL_URL;
    const token = localStorage.getItem('access_token');
    const authUser = JSON.parse(localStorage.getItem('authUser'));
    const companyId = this.$route.params.companyId || authUser.company.id;
    const route = this.route;
    window.location.href = `${portalUrl}/externallogin?token=${token}&route=${route}&companyId=${companyId}`;
  },
};
</script>



// WEBPACK FOOTER //
// index.vue?1ab3b65a